import { doc, getDoc } from "firebase/firestore";
import { db } from ".";

export const isAdminUser = async (uid: string, email?: string | null): Promise<boolean> => {
  // The admin doc may be keyed by uid or (legacy) by email. Both lookups run
  // concurrently — the email fallback used to be a second sequential round trip
  // paid by every non-admin user on every login.
  const [uidSnap, emailSnap] = await Promise.all([
    getDoc(doc(db, "admins", uid)),
    email ? getDoc(doc(db, "admins", email)) : Promise.resolve(null),
  ]);

  return uidSnap.exists() || !!emailSnap?.exists();
};
